import React, { useEffect, useState } from "react";
import { navigate } from "@reach/router";

import { useUser } from "../../../hooks/useApi";

import DevPre from "../../dev/DevPre";
import Loader from "../../basic/Loader";
import FacebookButton from "../../FacebookButton";
import AppleButton from "../../AppleButton";
import GoogleButton from "../../GoogleButton";

import SonicboxLogoPNG from "../../../images/sonicbox-logo.png";
import "../../../styles/index.scss";
import "./styles/style.scss";

import { T } from "../../../hooks/useLanguage";
import EmailLoginButton from "../../EmailLoginButton";
import { getLoginResumePath } from "../../../features/entryFlow/entryIntentStorage";

import EntryAuthGuard from "../../../features/entryFlow/EntryAuthGuard";

export default function Home() {
  const { logged, loginRedirect } = useUser();
  const [isLoading] = useState(false); // setIsLoading

  useEffect(() => {
    // console.log("useEffect logged", logged);
    if (logged) {
      navigate(
        getLoginResumePath(
          loginRedirect && loginRedirect !== "" ? loginRedirect : "/sonicboxes",
        ),
      );
    }
  }, [logged, loginRedirect]);

  return (
    <EntryAuthGuard>
      <div className="container index-page">
        <img src={SonicboxLogoPNG} alt="Sonicbox logo" className="page-logo" />
        <p>
          <T>home.welcome</T>
        </p>
        <DevPre>
          {typeof logged} - {logged ? "logged" : "not logged"}
        </DevPre>
        <h1>
          <T>home.title</T>
        </h1>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <FacebookButton />
            <GoogleButton />
            <AppleButton />
            <EmailLoginButton />
            <p>
              <span className="link as-link">
                <T>home.mustlogin</T>
              </span>
            </p>
          </>
        )}
      </div>
    </EntryAuthGuard>
  );
}
